// src/internal/components/help-center-panel/help-center-article/help-center-article.styles.tsx
import { css, styled } from "@mui/material/styles";
var StyledContentWrapper = styled("div")(
  ({ theme }) => css`
      a {
        color: ${theme.palette.v3.complementary.link};
      }

      p {
        margin-bottom: 12px;
      }

      img {
        margin: 0 auto;
        max-width: 100%;
      }

      h1 {
        font-size: 36px;
        font-weight: 600;
      }

      h2 {
        font-size: 28px;
        font-weight: 600;
      }

      h3 {
        font-size: 24px;
        font-weight: 600;
      }

      iframe {
        width: 100%;
        margin-bottom: 20px;
      }

      .wysiwyg-text-align-center {
        text-align: center;
      }

      .btn {
        display: table;
        margin: auto;
        padding: 8px 16px;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        cursor: pointer;
        text-decoration: none;
        transition: background-color 0.3s;
        border-radius: 8px;
        user-select: none;

        &.btn-primary {
          background-color: ${theme.palette.v3.primary.default};
          color: ${theme.palette.v3.primary.on_primary.high};

          &:hover {
            background-color: ${theme.palette.v3.primary.hover};
          }
        }

        &.btn-secondary {
          background-color: ${theme.palette.v3.primary.on_primary.high};
          border: 2px solid ${theme.palette.v3.primary.default};
          color: ${theme.palette.v3.primary.default};

          &:hover {
            background-color: ${theme.palette.v3.bg.hover};
            border-color: ${theme.palette.v3.primary.hover};
            color: ${theme.palette.v3.primary.hover};
          }
        }
      }

      ol {
        list-style: none;
        counter-reset: item;
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-top: 20px;

        li {
          counter-increment: item;
          margin-bottom: 5px;
          display: flex;
          gap: 8px;
        }

        li:before {
          margin: auto 0;
          content: counter(item) '.';
          display: flex;
          justify-content: center;
        }

        &.rounded {
          li:before {
            background: ${theme.palette.v3.bg.info};
            border-radius: 100%;
            color: ${theme.palette.v3.primary.default};
            content: counter(item);
            width: 20px;
            height: 20px;
            font-size: 14px;
            font-weight: 600;
            min-width: 20px;
            margin-top: 2px;
          }
        }
      }

      .additional-links {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      ul {
        list-style: none;

        li {
          margin-left: 20px;
          margin-bottom: 12px;
          position: relative;

          &::before {
            content: '';
            margin-top: 7px;
            background: ${theme.palette.v3.primary.default};
            position: absolute;
            left: -20px;
            width: 10px;
            height: 10px;
            border-radius: 50%;
          }
        }
      }

      .banner {
        display: flex;
        justify-content: space-between;
        border-radius: 8px;
        padding: 8px 16px;
        font-size: 14px;
        font-weight: 400;

        a {
          min-width: fit-content;
          margin: auto 0;
        }

        &.info {
          background: ${theme.palette.v3.bg.info};
          color: ${theme.palette.v3.content.info};

          p::before {
            background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 21.75C10.0716 21.75 8.18657 21.1782 6.58319 20.1068C4.97982 19.0355 3.73013 17.5127 2.99218 15.7312C2.25422 13.9496 2.06114 11.9892 2.43735 10.0979C2.81355 8.20655 3.74215 6.46927 5.10571 5.10571C6.46928 3.74215 8.20656 2.81355 10.0979 2.43734C11.9892 2.06114 13.9496 2.25422 15.7312 2.99218C17.5127 3.73013 19.0355 4.97981 20.1068 6.58319C21.1782 8.18657 21.75 10.0716 21.75 12C21.7473 14.585 20.7192 17.0634 18.8913 18.8913C17.0634 20.7192 14.585 21.7473 12 21.75ZM12 3.75C10.3683 3.75 8.77326 4.23385 7.41655 5.14038C6.05984 6.0469 5.00242 7.33537 4.378 8.84286C3.75358 10.3504 3.5902 12.0092 3.90853 13.6095C4.22685 15.2098 5.01259 16.6798 6.16637 17.8336C7.32016 18.9874 8.79017 19.7732 10.3905 20.0915C11.9909 20.4098 13.6497 20.2464 15.1571 19.622C16.6646 18.9976 17.9531 17.9402 18.8596 16.5835C19.7662 15.2267 20.25 13.6317 20.25 12C20.2475 9.81273 19.3775 7.71575 17.8309 6.16911C16.2843 4.62247 14.1873 3.75248 12 3.75ZM11.25 11.25V16.5C11.25 16.6989 11.329 16.8897 11.4697 17.0303C11.6103 17.171 11.8011 17.25 12 17.25C12.1989 17.25 12.3897 17.171 12.5303 17.0303C12.671 16.8897 12.75 16.6989 12.75 16.5V11.25C12.75 11.0511 12.671 10.8603 12.5303 10.7197C12.3897 10.579 12.1989 10.5 12 10.5C11.8011 10.5 11.6103 10.579 11.4697 10.7197C11.329 10.8603 11.25 11.0511 11.25 11.25ZM13.125 7.875C13.125 7.6525 13.059 7.43499 12.9354 7.24998C12.8118 7.06498 12.6361 6.92078 12.4305 6.83564C12.225 6.75049 11.9988 6.72821 11.7805 6.77162C11.5623 6.81502 11.3618 6.92217 11.2045 7.07951C11.0472 7.23684 10.94 7.43729 10.8966 7.65552C10.8532 7.87375 10.8755 8.09995 10.9606 8.30552C11.0458 8.51109 11.19 8.68679 11.375 8.8104C11.56 8.93402 11.7775 9 12 9C12.2984 9 12.5845 8.88147 12.7955 8.67049C13.0065 8.45952 13.125 8.17337 13.125 7.875Z" fill="%23244EB0"/></svg>');
          }
        }

        &.warning {
          background: ${theme.palette.v3.bg.warning};
          color: ${theme.palette.v3.content.warning};

          p::before {
            background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.2 17.6334L14.0016 3.39563C13.7967 3.04681 13.5042 2.75758 13.1532 2.55662C12.8021 2.35566 12.4046 2.24994 12 2.24994C11.5955 2.24994 11.198 2.35566 10.8469 2.55662C10.4958 2.75758 10.2033 3.04681 9.99847 3.39563L1.80003 17.6334C1.60291 17.9708 1.49902 18.3546 1.49902 18.7453C1.49902 19.1361 1.60291 19.5198 1.80003 19.8572C2.00228 20.2081 2.29425 20.4989 2.64599 20.6997C2.99773 20.9006 3.39658 21.0042 3.80159 21H20.1985C20.6032 21.0039 21.0016 20.9001 21.353 20.6993C21.7044 20.4985 21.9961 20.2078 22.1982 19.8572C22.3956 19.52 22.4998 19.1363 22.5001 18.7456C22.5004 18.3548 22.3969 17.971 22.2 17.6334ZM20.8997 19.1063C20.8282 19.2282 20.7256 19.3289 20.6024 19.3981C20.4792 19.4673 20.3398 19.5024 20.1985 19.5H3.80159C3.66029 19.5024 3.52088 19.4673 3.39765 19.3981C3.27442 19.3289 3.17181 19.2282 3.10034 19.1063C3.0356 18.9966 3.00145 18.8717 3.00145 18.7444C3.00145 18.6171 3.0356 18.4921 3.10034 18.3825L11.2988 4.14469C11.3717 4.02335 11.4748 3.92295 11.598 3.85324C11.7212 3.78354 11.8603 3.7469 12.0019 3.7469C12.1435 3.7469 12.2826 3.78354 12.4058 3.85324C12.529 3.92295 12.6321 4.02335 12.705 4.14469L20.9035 18.3825C20.9676 18.4924 21.0011 18.6176 21.0005 18.7449C20.9998 18.8722 20.965 18.997 20.8997 19.1063ZM11.25 13.5V9.75C11.25 9.55109 11.329 9.36032 11.4697 9.21967C11.6104 9.07902 11.8011 9 12 9C12.1989 9 12.3897 9.07902 12.5304 9.21967C12.671 9.36032 12.75 9.55109 12.75 9.75V13.5C12.75 13.6989 12.671 13.8897 12.5304 14.0303C12.3897 14.171 12.1989 14.25 12 14.25C11.8011 14.25 11.6104 14.171 11.4697 14.0303C11.329 13.8897 11.25 13.6989 11.25 13.5ZM13.125 16.875C13.125 17.0975 13.059 17.315 12.9354 17.5C12.8118 17.685 12.6361 17.8292 12.4305 17.9144C12.225 17.9995 11.9988 18.0218 11.7806 17.9784C11.5623 17.935 11.3619 17.8278 11.2045 17.6705C11.0472 17.5132 10.9401 17.3127 10.8966 17.0945C10.8532 16.8762 10.8755 16.65 10.9607 16.4445C11.0458 16.2389 11.19 16.0632 11.375 15.9396C11.56 15.816 11.7775 15.75 12 15.75C12.2984 15.75 12.5845 15.8685 12.7955 16.0795C13.0065 16.2905 13.125 16.5766 13.125 16.875Z" fill="%23483C10"/></svg>');
          }
        }

        &.critical {
          background: ${theme.palette.v3.bg.critical};
          color: ${theme.palette.v3.content.critical};

          p::before {
            background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" fill="%23B00020" d="M15.5306 9.53063L13.0603 12L15.5306 14.4694C15.6003 14.5391 15.6556 14.6218 15.6933 14.7128C15.731 14.8039 15.7504 14.9015 15.7504 15C15.7504 15.0985 15.731 15.1961 15.6933 15.2872C15.6556 15.3782 15.6003 15.4609 15.5306 15.5306C15.4609 15.6003 15.3782 15.6556 15.2872 15.6933C15.1961 15.731 15.0986 15.7504 15 15.7504C14.9015 15.7504 14.8039 15.731 14.7128 15.6933C14.6218 15.6556 14.5391 15.6003 14.4694 15.5306L12 13.0603L9.53063 15.5306C9.46095 15.6003 9.37822 15.6556 9.28718 15.6933C9.19613 15.731 9.09855 15.7504 9 15.7504C8.90146 15.7504 8.80388 15.731 8.71283 15.6933C8.62179 15.6556 8.53906 15.6003 8.46938 15.5306C8.3997 15.4609 8.34442 15.3782 8.30671 15.2872C8.269 15.1961 8.24959 15.0985 8.24959 15C8.24959 14.9015 8.269 14.8039 8.30671 14.7128C8.34442 14.6218 8.3997 14.5391 8.46938 14.4694L10.9397 12L8.46938 9.53063C8.32865 9.38989 8.24959 9.19902 8.24959 9C8.24959 8.80098 8.32865 8.61011 8.46938 8.46937C8.61011 8.32864 8.80098 8.24958 9 8.24958C9.19903 8.24958 9.3899 8.32864 9.53063 8.46937L12 10.9397L14.4694 8.46937C14.5391 8.39969 14.6218 8.34442 14.7128 8.3067C14.8039 8.26899 14.9015 8.24958 15 8.24958C15.0986 8.24958 15.1961 8.26899 15.2872 8.3067C15.3782 8.34442 15.4609 8.39969 15.5306 8.46937C15.6003 8.53906 15.6556 8.62178 15.6933 8.71283C15.731 8.80387 15.7504 8.90145 15.7504 9C15.7504 9.09855 15.731 9.19613 15.6933 9.28717C15.6556 9.37822 15.6003 9.46094 15.5306 9.53063ZM21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46928 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96452 6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12ZM20.25 12C20.25 10.3683 19.7662 8.77325 18.8596 7.41655C17.9531 6.05984 16.6646 5.00242 15.1571 4.37799C13.6497 3.75357 11.9909 3.59019 10.3905 3.90852C8.79017 4.22685 7.32016 5.01259 6.16637 6.16637C5.01259 7.32015 4.22685 8.79016 3.90853 10.3905C3.5902 11.9908 3.75358 13.6496 4.378 15.1571C5.00242 16.6646 6.05984 17.9531 7.41655 18.8596C8.77326 19.7661 10.3683 20.25 12 20.25C14.1873 20.2475 16.2843 19.3775 17.8309 17.8309C19.3775 16.2843 20.2475 14.1873 20.25 12Z"/></svg>');
          }
        }

        p {
          display: flex;
          overflow-wrap: break-word;

          &::before {
            content: '';
            display: flex;
            margin: auto 8px auto 0;
            width: 20px;
            height: 20px;
            min-width: 20px;
          }
        }
      }
    `
);

export {
  StyledContentWrapper
};
